import React from 'react';
import { FolderOpenIcon, EyeIcon, GuitarIcon, ArrowRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const steps = [{
  icon: FolderOpenIcon,
  title: 'Wchodzisz',
  text: 'Otwierasz plik z tygodniem, który masz dziś do przerobienia. Bez szukania, bez logowania.'
}, {
  icon: EyeIcon,
  title: 'Patrzysz',
  text: 'Widzisz temat, ćwiczenie dla poziomu ucznia i stronę z teorią do wyjaśnienia. Wszystko na jednej stronie.'
}, {
  icon: GuitarIcon,
  title: 'Uczysz',
  text: 'Drukujesz i wchodzisz na lekcję przygotowany. Zero przygotowań w niedzielę wieczorem.'
}];

/** Core promise: the material is ready to use — open, look, teach. */
export function ReadyToTeach() {
  return <section aria-labelledby="ready-heading" className="bg-night py-14 sm:py-24" data-id="element-318" data-mp="1rm5i6k61quto">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-319" data-mp="c66p8g5035e0">
        <div className="mx-auto max-w-3xl text-center" data-id="element-320" data-mp="g8bgx9bw1ry0">
          <Eyebrow align="center" data-id="element-321" data-mp="ga4melarm64f">Gotowe do użycia</Eyebrow>
          <h2 id="ready-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-322" data-mp="3izibn6gpxv1a">
            Wchodzisz, patrzysz, <span className="text-amber" data-id="element-323" data-mp="3e2i22lknua5f">uczysz. Gotowe.</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic leading-relaxed text-cream-soft sm:text-xl" data-id="element-324" data-mp="3s1ri9l8v949e">
            Zaplanowaliśmy za Ciebie cały semestr i przygotowaliśmy wszystkie materiały. Nic nie musisz
            tworzyć, przepisywać ani dopasowywać — Ty tylko uczysz.
          </p>
        </div>
        <ol className="mt-8 grid gap-3 sm:mt-14 sm:gap-5 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-stretch lg:gap-4" data-id="element-325" data-mp="tdogxbbjw9n">
          {steps.map(({
          icon: Icon,
          title,
          text
        }, index) => <React.Fragment key={title} data-id="element-326" data-mp="ajyjkarsaint" data-mpi={index}>
              <li className="flex items-start gap-4 rounded-2xl border border-night-600 bg-night-800 p-5 sm:p-7 lg:flex-col lg:gap-0" data-id="element-327" data-mp="al06pdm2qvlw">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber sm:h-12 sm:w-12" data-id="element-328" data-mp="jl6hgrqe1hhd">
                  <Icon className="h-5 w-5 text-night sm:h-6 sm:w-6" aria-hidden="true" data-id="element-329" data-mp="3ddnzrwnrfu24" />
                </span>
                <div className="lg:mt-6" data-id="element-330" data-mp="3id0tn1d1u1e7">
                  <h3 className="font-display text-2xl leading-none text-cream sm:text-3xl" data-id="element-331" data-mp="3i9lejyjdkscs">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-cream-soft sm:mt-3 sm:text-base" data-id="element-332" data-mp="3mbq5gpifvavq">{text}</p>
                </div>
              </li>
              {index < steps.length - 1 && <li aria-hidden="true" className="hidden items-center justify-center lg:flex" data-id="element-333" data-mp="chcbdtx3mk">
                  <ArrowRightIcon className="h-6 w-6 text-amber" data-id="element-334" data-mp="4yw60jjt4tim" />
                </li>}
            </React.Fragment>)}
        </ol>
        <p className="mt-8 text-center text-xs font-semibold uppercase leading-relaxed tracking-label text-amber sm:mt-10 sm:text-sm" data-id="element-335" data-mp="dwq1js9qzj4q">
          Zero przygotowań · Zero szukania · Gotowe na jutrzejszą lekcję
        </p>
      </div>
    </section>;
}